import { useStore } from 'zustand';
import { useChartShapes } from '@/contexts';

export const useHideShape = () => {
  // Get from contexts
  const { shapeStore } = useChartShapes();
  const setRenderNodes = useStore(shapeStore, s => s.setRenderNodes);

  // Handle shape hiding
  const handleHide = (key: string) => {
    setRenderNodes(prev => {
      const updated = { ...prev };

      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      for (const chartId of Object.keys(updated) as Array<keyof typeof updated>) {
        const chartShapes = updated[chartId];

        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        for (const type of Object.keys(chartShapes) as Array<keyof typeof chartShapes>) {
          const shapeArray = chartShapes[type];
          if (!shapeArray) continue;
          const index = shapeArray.findIndex(shape => shape.uuid === key);
          if (index !== -1) {
            // shallow copy only the affected parts
            updated[chartId] = { ...chartShapes };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion -- RenderNodesMap의 mapped type에서 spread 반환 타입 호환을 위한 캐스트
            (updated[chartId] as any)[type] = [...shapeArray];

            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-type-assertion
            (updated[chartId] as any)[type][index] = {
              ...shapeArray[index],
              hidden: !shapeArray[index].hidden,
              selected: shapeArray[index].hidden, // also deselect if hiding
            };
            shapeStore.getState().markDirty(key);
            return updated; // exit immediately
          }
        }
      }
      return prev; // nothing found
    });
  };

  return { handleHide };
};
